import config from '../package.json';

const ID = `${config.name}/actions/ehubActions`;
const createActionName = (name: string) => `app/${ID}/${name}`;

export const COMPONENT_MOUNTED = createActionName('COMPONENT_MOUNTED');
export const CONTENT_LOADED = createActionName('CONTENT_LOADED');
export const EHUB_ID_RETRIEVED = createActionName('EHUB_ID_RETRIEVED');
export const GO_TO = createActionName('GO_TO');
export const OPEN_EHUB_DISCLAIMER = createActionName('OPEN_EHUB_DISCLAIMER');

export const FETCH_EHUB_AUTH_TOKEN = createActionName('FETCH_EHUB_AUTH_TOKEN');

export const fetchEHubAuthToken = (
  url: string,
  fetchEHubAuthTokenSuccess: (payload: any) => void,
  fetchEHubAuthTokenFailure: (error: any) => void,
) => ({
  type: FETCH_EHUB_AUTH_TOKEN,
  payload: {
    url,
    fetchEHubAuthTokenSuccess,
    fetchEHubAuthTokenFailure,
  },
});

export const goTo = (cardViewId: string, url: string) => ({
  type: GO_TO,
  payload: {
    url,
    cardViewId,
  },
});

export const openEHubDisclaimer = (
  disclaimerId: string,
  cardViewId: string,
) => ({
  type: OPEN_EHUB_DISCLAIMER,
  payload: {
    disclaimerId,
    cardViewId,
  },
});
